import { c as _c } from "react/compiler-runtime";
import { Box, Flex, HStack, Heading, Image, Separator, SimpleGrid, Stack, StackProps, Text, VStack } from '@chakra-ui/react';
import { CardCarousel } from '@src/components/sco/CardCarousel';
import { MobileBottomControl } from '@src/components/sco/CardCarousel/Controls/MobileBottomControl';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export const AcquisitionsBlock: React.FC = () => {
  const $ = _c(47);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isMobile = t0;
  let t1;
  if ($[2] !== getBreakpointValue) {
    t1 = getBreakpointValue([false, false, true, false, false]);
    $[2] = getBreakpointValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isTablet = t1;
  const t2 = isMobile ? "xl" : "3xl";
  let t3;
  if ($[4] !== getBreakpointValue) {
    t3 = getBreakpointValue([4, 4, 10, 10, 10]);
    $[4] = getBreakpointValue;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Separator flex="1" />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== getBreakpointValue) {
    t5 = getBreakpointValue(["xl", "2xl", "3xl"]);
    $[7] = getBreakpointValue;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <Text color="purple.fg" fontSize={t5} fontWeight={700} letterSpacing="wide" textAlign="center" textStyle="heading" textTransform="uppercase">Acquisitions</Text>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Separator flex="1" />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6) {
    t8 = <HStack align="center" gap={10} justify="center" width="full">{t4}{t6}{t7}</HStack>;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== getBreakpointValue) {
    t9 = getBreakpointValue(["column", "column", "row"]);
    $[14] = getBreakpointValue;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = isMobile || isTablet ? 0 : 6;
  const t11 = isMobile ? 8 : 0;
  const t12 = isMobile ? "center" : "left";
  let t13;
  if ($[16] !== getBreakpointValue) {
    t13 = getBreakpointValue(["3xl", "4xl", "5xl"]);
    $[16] = getBreakpointValue;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== getBreakpointValue) {
    t14 = getBreakpointValue(["center", "center", "left"]);
    $[18] = getBreakpointValue;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t13 || $[21] !== t14) {
    t15 = <Heading color="red.fg" fontWeight={700} lineHeight={1} size={t13} textAlign={t14}>We don't just build startups - we buy them.</Heading>;
    $[20] = t13;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Text color="red.fg/75" fontSize="lg" fontWeight={600} opacity={1}>We've acquired quite a few VC-Funded Startups from some well-known investors.</Text>;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t15) {
    t17 = <Flex align="center" direction="column" gap={4} height="full" justify="end" marginBottom={t10} paddingY={t11} textAlign={t12} width="full">{t15}{t16}</Flex>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t15;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== isMobile || $[30] !== isTablet) {
    t18 = isMobile || isTablet ? <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
      top: false,
      bottom: MobileBottomControl
    }}><AcquisitionCard brandImageUrl={require("@public/brand-logos/zirtual.svg").default.src} brandImageWidth="120px" investorLogos={[require("@public/assets/graphics/client-logos/mayfield-logo.svg").default.src, require("@public/assets/graphics/client-logos/structure-capital-logo.png").default.src]} /><AcquisitionCard brandImageUrl={require("@public/brand-logos/launchrock.svg").default.src} brandImageWidth="150px" investorLogos={[require("@public/assets/graphics/client-logos/trinity-capital-logo.svg").default.src, require("@public/assets/graphics/client-logos/venture51-logo.svg").default.src, require("@public/assets/graphics/client-logos/500global-logo.svg").default.src]} /><AcquisitionCard brandImageUrl={require("@public/brand-logos/clarity.svg").default.src} brandImageWidth="120px" investorLogos={[require("@public/assets/graphics/client-logos/baseline-logo.png").default.src, require("@public/assets/graphics/client-logos/freestyle-logo.svg").default.src, require("@public/assets/graphics/client-logos/mcc-logo.svg").default.src]} /><AcquisitionCard brandImageUrl={require("@public/brand-logos/zana-logo.svg").default.src} brandImageWidth="120px" /><AcquisitionCard brandImageUrl={require("@public/brand-logos/killerstartups-logo.svg").default.src} /><AcquisitionCard brandImageUrl={require("@public/brand-logos/bizplan.svg").default.src} brandImageWidth="120px" /></CardCarousel> : <SimpleGrid columns={2} gap={4} width="full"><AcquisitionCard brandImageUrl={require("@public/brand-logos/zirtual.svg").default.src} brandImageWidth="120px" investorLogos={[require("@public/assets/graphics/client-logos/mayfield-logo.svg").default.src, require("@public/assets/graphics/client-logos/structure-capital-logo.png").default.src]} /><AcquisitionCard brandImageUrl={require("@public/brand-logos/launchrock.svg").default.src} brandImageWidth="150px" investorLogos={[require("@public/assets/graphics/client-logos/trinity-capital-logo.svg").default.src, require("@public/assets/graphics/client-logos/venture51-logo.svg").default.src, require("@public/assets/graphics/client-logos/500global-logo.svg").default.src]} /><AcquisitionCard brandImageUrl={require("@public/brand-logos/clarity.svg").default.src} brandImageWidth="120px" investorLogos={[require("@public/assets/graphics/client-logos/baseline-logo.png").default.src, require("@public/assets/graphics/client-logos/freestyle-logo.svg").default.src, require("@public/assets/graphics/client-logos/mcc-logo.svg").default.src]} /><AcquisitionCard brandImageUrl={require("@public/brand-logos/zana-logo.svg").default.src} brandImageWidth="120px" /><AcquisitionCard brandImageUrl={require("@public/brand-logos/killerstartups-logo.svg").default.src} /><AcquisitionCard brandImageUrl={require("@public/brand-logos/bizplan.svg").default.src} brandImageWidth="120px" /></SimpleGrid>;
    $[29] = isMobile;
    $[30] = isTablet;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] !== t17 || $[33] !== t18) {
    t19 = <VStack align="center" alignSelf="stretch" gap={4} justify="center" paddingBottom={10} width="full">{t17}{t18}</VStack>;
    $[32] = t17;
    $[33] = t18;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== isMobile || $[36] !== isTablet) {
    t20 = !isMobile && !isTablet ? <Flex align="center" alignSelf="stretch" borderRadius="md" direction="column" justify="end" position="relative" width="full"><Box position="absolute" width="800px" height="800px" bgImage="radial-gradient({colors.teal.fg/35}, transparent 70%)" /><Image alt="Zirtual Assistant Cutout" filter="drop-shadow(0 0 10px rgba(0, 0, 0, 0.35))" marginLeft={isMobile ? 0 : 10} objectFit="contain" src="/assets/graphics/about/zirtual-cutout.png" width={isMobile ? "75%" : "90%"} zIndex={10} /></Flex> : <></>;
    $[35] = isMobile;
    $[36] = isTablet;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t19 || $[39] !== t20 || $[40] !== t9) {
    t21 = <VStack align="start" gap={0} justify="center" maxWidth="container.xl" width="full"><Stack align="center" direction={t9} gap={0} justify="center" width="full">{t19}{t20}</Stack></VStack>;
    $[38] = t19;
    $[39] = t20;
    $[40] = t9;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t2 || $[43] !== t21 || $[44] !== t3 || $[45] !== t8) {
    t22 = <VStack align="center" borderRadius={t2} height="full" justify="stretch" overflow="hidden" padding={t3} paddingBottom={0} width="full" boxShadow="inset 0 1px 0 rgba(255, 255, 255, 0.2)" bgImage="linear-gradient({colors.purple.solid/50}, transparent, transparent, {colors.purple.solid/50})">{t8}{t21}</VStack>;
    $[42] = t2;
    $[43] = t21;
    $[44] = t3;
    $[45] = t8;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  return t22;
};
const AcquisitionCard: React.FC<{
  brandImageUrl: string;
  brandImageWidth?: string;
  investorLogos?: string[];
  stackProps?: StackProps;
}> = t0 => {
  const $ = _c(17);
  const {
    brandImageUrl,
    brandImageWidth,
    investorLogos,
    stackProps
  } = t0;
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t1;
  if ($[0] !== getBreakpointValue) {
    t1 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isMobile = t1;
  const t2 = brandImageWidth || "150px";
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      _light: "invert(1)",
      _dark: "invert(0)"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== brandImageUrl) {
    t4 = <Image alt="Brand Logo" filter={t3} src={brandImageUrl} />;
    $[3] = brandImageUrl;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <Box width={t2}>{t4}</Box>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== investorLogos || $[9] !== isMobile) {
    t6 = Array.isArray(investorLogos) ? <HStack align="center" gap={4} opacity={0.5}>{(investorLogos as string[]).map((img, i, arr) => <React.Fragment key={i}><Box width={isMobile ? "50px" : "50px"}><Image alt={`Investor Logo ${i + 1}`} filter={{
            _light: "invert(1)",
            _dark: "invert(0)"
          }} src={img} /></Box>{i < arr.length - 1 && <Box alignSelf="center" borderColor="purple.fg/50" borderLeft="2px solid" height="20px" mx={2} opacity={0.5} />}</React.Fragment>)}</HStack> : <></>;
    $[8] = investorLogos;
    $[9] = isMobile;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <VStack align="center" gap={4} justify="center">{t5}{t6}</VStack>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== stackProps || $[15] !== t7) {
    t8 = <Stack align="center" aspectRatio="16/9" border="1px solid" borderColor="purple.fg/30" borderRadius="lg" direction="row" gap={4} justify="center" padding={4} width="full" {...stackProps}>{t7}</Stack>;
    $[14] = stackProps;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};